import { useState } from 'react';

/**
 * ログインエラーの状態管理用カスタムフック
 */
export const useStateLoginError = () => {
	const [isLoginError, setIsLoginError] = useState(false); // ログインエラーの状態管理
	const [isLoginLockError, setIsLoginLockError] = useState(false); // ログインロックエラーの状態管理
	const [needsChangeInitPassword, setNeedsChangeInitPassword] = useState(false); // 初期パスワード変更要求の状態管理
	const [isLocalStorageError, setIsLocalStorageError] = useState(false); // ローカルストレージエラーの状態管理

	// ログインエラーのアラートを閉じる際の処理
	const onCloseLoginErrorAlert = () => {
		setIsLoginError(false);
	};

	// ログインロックエラーのアラートを閉じる際の処理
	const onCloseLoginLockErrorAlert = () => {
		setIsLoginLockError(false);
	};

	const onCloseLocalStorageErrorAlert = () => {
		setIsLocalStorageError(false);
	}

	return {
		isLoginError,
		setIsLoginError,
		isLoginLockError,
		setIsLoginLockError,
		needsChangeInitPassword,
		setNeedsChangeInitPassword,
		isLocalStorageError,
		setIsLocalStorageError,
		onCloseLoginErrorAlert,
		onCloseLoginLockErrorAlert,
		onCloseLocalStorageErrorAlert
	};
};
